// extracted by mini-css-extract-plugin
module.exports = {"container":"Content_container__2a-Yc","content":"Content_content__1hbGh","mainContent":"Content_mainContent__24S3l","photo":"Content_photo__2GFcb"};